/** 与后端 BaseResultCodeConstants / oauth ResultCodeConstants 对齐 */
export const AUTH_RESULT_CODES = {
  SUCCESS: 200,
  PARAMS_ERROR: 400,
  SYSTEM_ERROR: 500,
  PASSWORD_ERROR: 1003,
  LOGIN_FAILED: 1005,
  PASSWORD_CONFIRM_NOT_EQUAL: 1007,
  VERIFICATION_CODE_ERROR: 1009,
  ACCOUNT_NOT_FOUND: 1010,
  VERIFICATION_CODE_FAIL: 2001,
  LOGIN_EMAIL_CODE_TOO_FREQUENT: 2002,
  LOGIN_EMAIL_CODE_DAILY_LIMIT: 2003,
  REGISTER_EMAIL_CODE_TOO_FREQUENT: 2004,
  REGISTER_EMAIL_CODE_DAILY_LIMIT: 2005,
  EMAIL_CODE_MAIL_DISABLED: 2006,
  REGISTER_EMAIL_CODE_INVALID: 2007,
  REGISTER_EMAIL_ALREADY_EXISTS: 2008,
  REGISTER_USERNAME_ALREADY_EXISTS: 2009,
  RESET_PASSWORD_EMAIL_NOT_FOUND: 2010,
  RESET_PASSWORD_EMAIL_CODE_TOO_FREQUENT: 2011,
  RESET_PASSWORD_EMAIL_CODE_DAILY_LIMIT: 2012,
  RESET_PASSWORD_EMAIL_CODE_INVALID: 2013,
  RESET_PASSWORD_TICKET_INVALID: 2014,
} as const;
